// import { useEffect, useRef } from "react";

import { useEffect, useRef } from "react";

// export const useFetchDataRealtimeSync = ({
//       notifications,
//       getData,
//       path
// }: {
//       notifications: any;
//       getData: () => void;
//       path: string;
// }) =>
// {
//       const lastNotifIdRef = useRef<string | number | null>(null);
//       const refreshTimeoutRef = useRef<any>(null);

//       // debounce refresh
//       const triggerRefresh = () =>
//       {
//             if (refreshTimeoutRef.current)
//             {
//                   clearTimeout(refreshTimeoutRef.current);
//             }

//             refreshTimeoutRef.current = setTimeout(() =>
//             {
//                   getData();
//             }, 800); // debounce 0.8s
//       };

//       // socket / redux notification sync
//       useEffect(() =>
//       {
//             if (!notifications?.length) return;

//             const latestNotif = notifications[0];
//             if (!latestNotif) return;

//             // tránh duplicate event
//             if (lastNotifIdRef.current === latestNotif.id) return;
//             lastNotifIdRef.current = latestNotif.id;

//             const tags: string[] = latestNotif?.tags || [];

//             const isRelated = tags.some((tag) =>
//                   tag.includes(path)
//             );

//             console.log(isRelated, 'isRelated');

//             if (isRelated)
//             {
//                   triggerRefresh();
//             }
//       }, [notifications]);

//       //  fallback polling chống socket delay
//       useEffect(() =>
//       {


//             const interval = setInterval(() =>
//             {
//                   getData();
//             }, 60000); // 60s fallback sync

//             return () => clearInterval(interval);
//       }, []);

//       return null;
// };

export const useFetchDataRealtimeSync = ({
      notifications,
      getData,
      path,
}: {
      notifications: any;
      getData: () => void;
      path: string;
}) =>
{
      const lastNotifIdRef = useRef<string | number | null>(null);
      const refreshTimeoutRef = useRef<any>(null);
      const getDataRef = useRef(getData);


      useEffect(() =>
      {
            getDataRef.current = getData;
      }, [getData]);

      const triggerRefresh = () =>
      {
            if (refreshTimeoutRef.current)
            {
                  clearTimeout(refreshTimeoutRef.current);
            }

            refreshTimeoutRef.current = setTimeout(() =>
            {
                  getDataRef.current();
            }, 800);
      };

      useEffect(() =>
      {
            if (!notifications?.length) return;

            const latestNotif = notifications[0];
            if (!latestNotif) return;

            if (lastNotifIdRef.current === latestNotif.id) return;
            lastNotifIdRef.current = latestNotif.id;

            const tags: string[] = latestNotif?.tags || [];

            const isRelated = tags.some((tag) => tag.includes(path));

            if (isRelated)
            {
                  triggerRefresh();
            }
      }, [notifications, path]);

      useEffect(() =>
      {
            const interval = setInterval(() =>
            {
                  getDataRef.current();
            }, 300000);

            return () => clearInterval(interval);
      }, []);

      return null;
};